export const MEMBER_TPA_PAGE_ID = 'member_page';
export const MEMBER_SETTINGS_TPA_PAGE_ID = 'member_settings_page';
